import clsx from 'clsx';
import { useMemo } from 'react';

import { mergeTailwindClasses } from '@pflegia/util/functions/style/merge-tailwind-classes';

interface CarouselProps {
  children: React.ReactNode;
  showFourGrids?: boolean;
  hideGradient?: boolean;
  /** Centers the cards when they fit in the row. Meant for up to 3 cards, more would not scroll on large screens. */
  centered?: boolean;
}

const Carousel: React.FC<CarouselProps> = ({ children, centered = false, hideGradient = false, showFourGrids = false }) => {
  const childs = useMemo(() => (Array.isArray(children) ? children : [children]), [children]);

  return (
    <div className='flex w-full flex-col'>
      <div className='relative overflow-hidden'>
        <div
          data-testid='relevant-articles-scroll-container'
          className={mergeTailwindClasses(
            'flex w-full snap-x snap-mandatory overflow-x-auto overflow-y-hidden pb-3',
            centered && 'justify-center-safe',
            !hideGradient && 'pr-8 sm:pr-12 lg:pr-16',
            centered && 'lg:pr-0',
          )}>
          {childs.map(child => (
            <div
              key={child.key}
              className={clsx('w-full shrink-0 snap-start px-1! sm:w-1/2', showFourGrids ? 'lg:w-1/3 xl:w-1/4' : 'xl:w-1/3')}>
              {child}
            </div>
          ))}
        </div>
        {childs.length > 1 && !hideGradient && (
          <div
            aria-hidden
            className={clsx(
              'pointer-events-none absolute top-0 right-0 bottom-3 z-10 w-8 bg-linear-to-l from-white via-white/85 to-transparent sm:w-12 sm:via-white/90 lg:w-16 lg:via-white/95',
              centered && 'lg:hidden',
            )}
          />
        )}
      </div>
    </div>
  );
};

export default Carousel;
